// extracted by mini-css-extract-plugin
export var actionText = "_n2-4";
export var container = "_n2-0";
export var leftSection = "_n2-1";
export var rightSection = "_n2-2";
export var settingsButton = "_n2-6";
export var settingsIcon = "_n2-7";
export var shortcut = "_n2-5";
export var shortcutGroup = "_n2-3";